import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvanceLineComponent } from './components/advance-line/advance-line.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ServiceAreaComponent } from './components/service-area/service-area.component';
import { RouterModule } from "@angular/router";


@NgModule({
  declarations: [
    AdvanceLineComponent,
    BreadcrumbComponent,
    ServiceAreaComponent,
  ],
    exports: [
        BreadcrumbComponent,
        AdvanceLineComponent,
        ServiceAreaComponent,
    ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class SharedModule { }
